export const historyTableConstant = {
    cols: [
        { field: '', header: '#', class: 'text-center' },
        {
            field: 'created_at',
            header: 'Date / Heure',
            width: '12rem',
        },
        {
            field: 'type_action',
            header: 'Operation',
            width: '13rem',
        },
        { field: 'action', header: 'Détails Operation', width: '27rem' },
        { field: 'source', header: 'Source [Utilisateur]', width: '27rem' },
        { field: '', header: 'Actions', class: 'text-center', width: '5rem' },
    ],
    globalFilterFields: ['created_at', 'type_action', 'action', 'source'],
};
